import * as React from "react";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useStore } from "stores/connect";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { getConfig } from "components/configurations/helpers";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { BootstrapModalForm, Button, Input } from "components/bootstrap";
import { IfPermitted } from "components/common";
import Spinner from "components/common/Spinner";
import "moment-duration-format";
import { DocumentationLink } from "components/support";
import DocsHelper from "util/DocsHelper";
const McpDocsLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(DocumentationLink, { text: children, page: DocsHelper.PAGES.MCP_SERVER, displayIcon: false });
const McpConfig = () => {
  const { t } = useTranslation("configurations");
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [modalConfig, setModalConfig] = useState(void 0);
  const [viewConfig, setViewConfig] = useState(void 0);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  useEffect(() => {
    ConfigurationsActions.list(ConfigurationType.MCP_CONFIG).then(() => {
      const config = getConfig(ConfigurationType.MCP_CONFIG, configuration);
      setViewConfig(config);
      setModalConfig(config);
    });
  }, [configuration]);
  const openModal = () => {
    setShowConfigModal(true);
  };
  const onModalClickEnableRemoteAccess = () => {
    setModalConfig({ ...modalConfig, enable_remote_access: !modalConfig.enable_remote_access });
  };
  const onModalClickEnableOutputSchema = () => {
    setModalConfig({ ...modalConfig, enable_output_schema: !modalConfig.enable_output_schema });
  };
  const onModalClickEnableInputValidation = () => {
    setModalConfig({ ...modalConfig, enable_input_validation: !modalConfig.enable_input_validation });
  };
  const onModalCancel = () => {
    setShowConfigModal(false);
    setModalConfig(viewConfig);
  };
  const onModalSave = () => {
    ConfigurationsActions.update(ConfigurationType.MCP_CONFIG, { ...modalConfig }).then(() => {
      setShowConfigModal(false);
    });
  };
  if (!viewConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, t("mcp.title")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("p", null, t("mcp.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "mcp.documentation_hint", components: { docsLink: /* @__PURE__ */ React.createElement(McpDocsLink, null) } })), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, t("mcp.remote_access")), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_remote_access ? t("markdown.enabled") : t("markdown.disabled")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("dt", null, t("mcp.output_schema")), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_output_schema ? t("markdown.enabled") : t("markdown.disabled")), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("dt", null, t("mcp.input_validation")), /* @__PURE__ */ React.createElement("dd", null, viewConfig.enable_input_validation ? t("markdown.enabled") : t("markdown.disabled"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: openModal }, t("shared.edit_configuration"))), showConfigModal && modalConfig && /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      bsSize: "large",
      title: t("mcp.update_title"),
      onSubmitForm: onModalSave,
      onCancel: onModalCancel,
      submitButtonText: t("shared.update_configuration")
    },
    /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-remote-access-checkbox",
        type: "checkbox",
        label: t("mcp.enable_remote_access"),
        name: "enabled",
        checked: modalConfig.enable_remote_access,
        onChange: onModalClickEnableRemoteAccess
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-output-schema-checkbox",
        disabled: !modalConfig.enable_remote_access,
        type: "checkbox",
        label: t("mcp.enable_output_schema"),
        name: "output-schema-enabled",
        checked: modalConfig.enable_output_schema,
        onChange: onModalClickEnableOutputSchema
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "enable-input-validation-checkbox",
        disabled: !modalConfig.enable_remote_access,
        type: "checkbox",
        label: t("mcp.enable_input_validation"),
        name: "input-validation-enabled",
        checked: modalConfig.enable_input_validation,
        onChange: onModalClickEnableInputValidation
      }
    ))
  ));
};
export default McpConfig;
